import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "retriesSection"];
  static values = {
    waitMinutesOptions: Array,
    sendViaOptions: Array,
  };

  connect() {
    // Check initial poll selection
    this.updateVisibility();
  }

  addRetry(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );
    this.containerTarget.insertAdjacentHTML("beforeend", content);
  }

  removeRetry(event) {
    event.preventDefault();
    const retryRow = event.currentTarget.closest(
      '[data-notification-retries-target="retry"]'
    );
    const destroyField = retryRow.querySelector(
      '[data-notification-retries-target="destroyField"]'
    );

    // If there's an id field, this is a persisted record - mark for destruction
    const idField = retryRow.querySelector('input[name*="[id]"]');
    if (idField && idField.value) {
      destroyField.value = "1";
      retryRow.style.display = "none";
    } else {
      // New record - just remove from DOM
      retryRow.remove();
    }
  }

  pollChanged(event) {
    this.updateVisibility();
  }

  updateVisibility() {
    if (!this.hasRetriesSectionTarget) return;

    // Prefer hidden input created by Semantic UI dropdown, fallback to native select
    const hiddenInput = this.element.querySelector(
      'input[type="hidden"][name*="[poll_id]"]'
    );
    const selectInput = this.element.querySelector('select[name*="[poll_id]"]');
    const source = hiddenInput || selectInput;
    if (!source) return;

    const pollValue = source.value;
    const hasPoll =
      pollValue &&
      pollValue !== "" &&
      pollValue !== "none" &&
      pollValue !== "0";

    if (hasPoll) {
      this.retriesSectionTarget.classList.remove("no-show");
    } else {
      this.retriesSectionTarget.classList.add("no-show");
    }
  }
}
